import { render, staticRenderFns } from "./ProgressiveNotification.vue?vue&type=template&id=b98d74f6&scoped=true"
import script from "./ProgressiveNotification.vue?vue&type=script&lang=js"
export * from "./ProgressiveNotification.vue?vue&type=script&lang=js"
import style0 from "./ProgressiveNotification.vue?vue&type=style&index=0&id=b98d74f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98d74f6",
  null
  
)

export default component.exports